import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import About from "../components/About";
import MeetFounder from "../components/MeetFounder";
import Services from "../components/Services";
import Portfolio from "../components/Portfolio";
import Testimonials from "../components/Testimonials";
import WhyChooseUs from "../components/WhyChooseUs";
import Pricing from "../components/Pricing";
import Locations from "../components/Locations";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(
          () => el.scrollIntoView({ behavior: "smooth", block: "start" }),
          80
        );
      }
    }
  }, [location]);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <MeetFounder />
        <Services />
        <Portfolio />
        <Testimonials />
        <WhyChooseUs />
        <Pricing />
        <Locations />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
